import { useState } from 'react';

export const useKeepScrollFor = (
  ref: React.RefObject<HTMLElement>,
  throttleMs = 100,
) => {
  const [scrollPosition, setScrollPosition] = useState(0);

  let timeout: NodeJS.Timeout;
  const handleScroll = () => {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      const currentScrollPosition = ref.current?.scrollTop || 0;
      setScrollPosition(currentScrollPosition);
    }, throttleMs);
  };

  return { handleScroll, scrollPosition };
};
